let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hsAS2")).then(() => parcelRequire('6PsK0'));